// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___cHaEI","img":"img___yS4M7"};